import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

const useAction = ({
  mutationFn,
  queryKey,
  message,
  shouldRefresh = true,
  onError = (error) => {
    console.log(error)
  },
}) => {
  const useActionMutation = () => {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: mutationFn,
      onSuccess: (res, variables) => {
        if (!shouldRefresh) {
          return
        }
        if (res.message && res.success) {
          toast.success(res.message)
        } else if (message) {
          toast.info(message)
        }

        queryClient.invalidateQueries(queryKey.lists())

        // Prefer id from mutation input so nested action responses can still refresh the current detail view.
        const detailId = variables?.offerId || variables?.id || res?._id || res?.data?._id

        if (detailId) {
          queryClient.invalidateQueries(queryKey.detail(detailId))
        }
      },
      onError: onError,
    })
  }
  return useActionMutation
}

export default useAction
